package org.example.zone360.pages.coachDetails.coachAssistAi


import androidx.compose.runtime.Composable
import androidx.compose.runtime.snapshots.SnapshotStateList
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionProperty
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.transform
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import org.example.zone360.models.ChatBotMessage
import org.example.zone360.models.DashboardChatState
import org.example.zone360.models.GetPlayerData
import org.example.zone360.models.GetSessionsData
import org.example.zone360.models.GetSingleCoachData
import org.example.zone360.theme.SitePalette
import org.example.zone360.utils.Res
import org.example.zone360.utils.SelectedData
import org.example.zone360.utils.SelectedLanguage
import org.jetbrains.compose.web.css.AnimationTimingFunction
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgba
import org.jetbrains.compose.web.css.vh
import org.jetbrains.compose.web.css.vw

@Composable
fun CoachAssistAIOverlay(
    breakpoint: Breakpoint,
    sitePalette: SitePalette,
    isChatOpen: Boolean,
    onDismiss: () -> Unit,
    userId: String,
    coachProfile: GetSingleCoachData?,
    selectedDataType: SelectedData,
    selectedLanguage: SelectedLanguage,
    allSessions: List<GetSessionsData>,
    showOverlay: Boolean,
    onShowOverlayChange: (Boolean) -> Unit,
    subscriptionPopup: (Boolean) -> Unit,
    coachPlayerList: List<GetPlayerData>,
    chatMessages: DashboardChatState
) {
    Box(
        modifier = Modifier
            .fillMaxSize()
            .styleModifier {
                property("pointer-events", if (isChatOpen) "auto" else "none")
            }
    ) {
        // Backdrop
        Box(
            modifier = Modifier
                .position(Position.Fixed)
                .top(0.px)
                .left(0.px)
                .width(100.vw)
                .height(100.vh)
                .zIndex(998)
                .backgroundColor(rgba(0, 0, 0, 0.5))
                .opacity(if (isChatOpen) 1f else 0f)
                .styleModifier {
                    property("pointer-events", if (isChatOpen) "auto" else "none")
                }
                .transition(
                    Transition.of(TransitionProperty.All, 300.ms, AnimationTimingFunction.EaseInOut)
                )
                .onClick { onDismiss() }
        )

        // Chatbot popup
        Box(
            modifier = Modifier
                .position(Position.Fixed)
                .top(50.percent)
                .left(50.percent)
                .width(if (breakpoint < Breakpoint.MD) 95.vw else 80.vw)
                .zIndex(999999)
                .transform {
                    translate((-50).percent, (-50).percent)
                    translateY(if (isChatOpen) 0.px else 30.px)
                    scale(if (isChatOpen) 1f else 0.96f)
                }
                .opacity(if (isChatOpen) 1f else 0f)
                .styleModifier {
                    property("pointer-events", if (isChatOpen) "auto" else "none")
                }
                .transition(
                    Transition.of(TransitionProperty.All, 300.ms, AnimationTimingFunction.EaseInOut)
                )
                .onClick { it.stopPropagation() } // Prevent backdrop click
        ) {
            Box(
                modifier = Modifier
                    .fillMaxSize()
                    .borderRadius(if (breakpoint < Breakpoint.MD) 0.px else 12.px)
            ) {
                CoachAssistAI(
                    onDismiss = onDismiss,
                    breakpoint = breakpoint,
                    sitePalette = sitePalette,
                    userId = userId,
                    getCoachInfo = coachProfile ?: GetSingleCoachData(),
                    selectedSessionType = selectedDataType,
                    selectedLanguage = selectedLanguage,
                    sessionList = allSessions,
                    showOverlay = showOverlay,
                    onShowOverlayChange = onShowOverlayChange,
                    subscriptionPopup = subscriptionPopup,
                    playersList = coachPlayerList,
                    isChatOpen = true,
                    onExpandToggle = { onDismiss() },
                    scrollContainerId = Res.Id.coachOverlay,
                    messageInputId = Res.Id.coachPopupInputField,
                    chatMessages = chatMessages
                )
            }
        }
    }
}
